<script setup lang="ts">
import { MailingCard } from '@/@types/participant'
import Event from '@/assets/main/event.webp'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardTitle } from '@/components/ui/card'
import CardHeader from '@/components/ui/card/CardHeader.vue'
import { Link } from '@inertiajs/vue3'
import { Ticket } from 'lucide-vue-next'

defineProps<{ mailing: MailingCard }>()
</script>

<template>
    <Card class="flex h-auto flex-col gap-4 rounded-2xl border-none shadow-md">
        <CardHeader class="relative h-64 w-full rounded-2xl xl:h-80 2xl:h-90">
            <img :src="Event" alt="" class="absolute inset-0 h-full w-full rounded-2xl object-cover p-2" />
        </CardHeader>
        <CardContent class="flex flex-col gap-4">
            <CardTitle class="flex gap-4 font-sans text-xl text-gray-800">
                {{ mailing.workshop_description }}
            </CardTitle>
            <CardDescription class="flex flex-col gap-4 text-base font-medium text-slate-800">
                <span>{{ $t('Ticket type') }}: {{ $t(mailing.ticket_category) }}</span>
                <span>
                    {{ $t('Status') }}:
                    <Badge :variant="mailing.status">
                        {{ $t(mailing.status) }}
                    </Badge>
                </span>
                <span class="break-all"> {{ $t('Code') }}: {{ mailing.code }}</span>
            </CardDescription>
        </CardContent>
        <CardFooter class="flex flex-col items-start gap-4 text-gray-600">
            <div class="flex w-full gap-2">
                <Button class="w-full" :as="Link" :href="`/participant/mailings/${mailing.id}/edit`">
                    <Ticket />
                    <span v-if="mailing.status == 'invited'">
                        {{ $t('Complete registration') }}
                    </span>
                    <span v-else>
                        {{ $t('Update information') }}
                    </span>
                </Button>
            </div>
        </CardFooter>
    </Card>
</template>
